import { render, staticRenderFns } from "./EnsTab.vue?vue&type=template&id=d94737a0&"
import script from "./EnsTab.vue?vue&type=script&lang=js&"
export * from "./EnsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports